import { customStyles } from '../../styles/customStyles';
import { useState } from 'react';

const StylesSection = () => {
  const [currentPage, setCurrentPage] = useState(0);

  const styles = [
    { image: '/stil/creatives-jewelry-mannequin.png.jpeg', title: 'Ювелирные креативы' },
    { image: '/stil/creatives-jewelry-model.png.jpeg', title: 'Нуар стили' },
    { image: '/stil/decompose-preview.png.jpeg', title: 'Разбор на части' },
    { image: '/stil/doposle-2.jpeg', title: 'До-после' },
    { image: '/stil/example-2.webp', title: 'Креативный' },
    { image: '/stil/example-3-2.webp', title: 'Дизайнерский' },
    { image: '/stil/example-3-3.webp', title: 'На реалистичной модели' },
    { image: '/stil/instruction.jpeg', title: 'Инструкции' },
    { image: '/stil/preview.webp', title: 'Конверсионные' },
    { image: '/stil/razmer-2.jpg', title: 'Таблицы размеров' }
  ];

  const itemsPerPage = 4;
  const totalPages = Math.ceil(styles.length / itemsPerPage);

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const prevPage = () => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const currentStyles = styles.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <section id="styles" className="py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-12 flex flex-col md:flex-row justify-between items-end gap-8">
        <div>
          <h2 className="font-serif-display text-5xl lg:text-6xl mb-4">Выбирайте любой <span className="italic text-[#b7eb6f]">стиль</span> под задачу</h2>
          <p className="font-sans text-lg opacity-80 max-w-lg">
            Trippy — это не один шаблон. Это библиотека стилей для любых задач.
          </p>
        </div>
        <div className="flex gap-4">
          <button 
            onClick={prevPage}
            className="w-12 h-12 rounded-full border border-[#1F1F1F]/20 flex items-center justify-center hover:bg-[#b7eb6f] hover:border-[#b7eb6f] transition-colors"
          >
            <i className="ph ph-arrow-left"></i>
          </button>
          <button 
            onClick={nextPage}
            className="w-12 h-12 rounded-full border border-[#1F1F1F]/20 flex items-center justify-center hover:bg-[#b7eb6f] hover:border-[#b7eb6f] transition-colors"
          >
            <i className="ph ph-arrow-right"></i>
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {currentStyles.map((style, index) => (
            <div key={index} className="group">
              <div className="w-full h-[400px] bg-white p-2 transition-transform duration-300 hover:scale-105" style={customStyles.paperCard}>
                <div className="w-full h-full relative overflow-hidden rounded">
                  <img 
                    src={style.image} 
                    alt={style.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 text-xs font-sans border border-black/5 rounded">
                    {style.title}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StylesSection;
